const constants = {
	BASE_URL: "https://beta.norlics.ng/api",
	BASE1_URL: "https://beta.norlics.ng/api"
	// BASE1_URL: "https://enugutest1-zwbxjl4eea-uc.a.run.app/api"
};

export default constants;
